/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: frontgen
 * Version: 6.07.22
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function($) {
    'use strict';

    //MENU PRINCIPAL
    //$('#cssmenu > ul').prepend('<li class="mobile"><a href="#"><span>Menu <i class="fa fa-bars"></i></span></a></li>');
    $('#cssmenu > ul > li > a').on('click touchstart', function(e) { 
      $('#cssmenu li').removeClass('active');
      if ($('.activefrom').length ) {
         $('#cssmenu li').removeClass('activefrom');
      }
      $(this).closest('li').addClass('active'); 
      var checkElement = $(this).next();
      if((checkElement.is('ul')) && (checkElement.is(':visible'))) {
        $(this).closest('li').removeClass('active');
        checkElement.slideToggle(1);
        $('#cssmenu > ul > li.active:after').css("display","none");
      }
      if((checkElement.is('ul')) && (!checkElement.is(':visible'))) {
        $('.niv1 button').css("display","block");
        $('#cssmenu ul ul:visible').slideUp(1);
        checkElement.slideDown(1);
      }
      if( $(this).parent().hasClass('mobile') ) {
        e.preventDefault();
        $('#cssmenu').toggleClass('expand');
        if ( ($(this).parent().hasClass("active")) && (!$('#cssmenu ul li.has-sub ul').is(':visible'))  ){
            $(this).parent().removeClass('active');
        }
       // $(this).closest('li').removeClass('active');
      }
      if($(this).closest('li').find('ul').children().length == 0) {
        return true;
      } else {
        return false; 
      }   
    });

    $('.niv1 button').click(function () {
      $('#cssmenu ul ul:visible').slideUp(1);
        $('#cssmenu > ul > li.active').removeClass('active');
     });

    //FERMETURE DU MENU LORS DU CLICK EN DEHORS
    $(document).bind('click', function(e) {
      var $clicked = $(e.target);
      if (! $clicked.parents().hasClass("active")  ) {
        if (! $("div#cssmenu").hasClass("expand")) {
          $('#cssmenu ul li.has-sub ul:visible').hide();
        }
        $('#cssmenu > ul > li.active').removeClass('active');
      }
      if (! $clicked.parents().parents().parents().hasClass("expand")) {
          $('div#cssmenu.expand').removeClass('expand');
        }
    });

})(jQuery.noConflict());
